import {ChecklistDefinitionResponseBody} from '@dms/api/core';

import {ChecklistFormValue} from '../types/ChecklistFormValue';

export const toChecklistFormValue = (
  data: ChecklistDefinitionResponseBody
): ChecklistFormValue => ({
  name: data.name,
  resourceId: data.resourceId,
  description: data.description,
  tasks: data.tasks.map((task) => ({
    id: task.id,
    description: task.description,
    isMandatory: task.isMandatory,
    fileRequired: task.fileRequired,
  })),
});
